module.exports = __webpack_public_path__ + "media/images/emblems/Flueelen-coat_of_arms-a18897e674f0f1c1548cd0c67ab2c505.svg";